<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Destek Talep Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="AdSoyad"
        label="Tanım">
      </el-table-column>
      <el-table-column
        prop="DurumText"
        label="Durum"
        width="90"
      align="right">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        Height: '470px'
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'panel/destek'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelDestek.vue